import { AxiosError, InternalAxiosRequestConfig } from "axios";

import { getAuthClient } from "@/modules/authorisation/authClient";

export async function onRequestSuccess(config: InternalAxiosRequestConfig) {
  try {
    const authClient = await getAuthClient();
    const token = await authClient.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  } catch (e) {
    const authClient = await getAuthClient();
    await authClient.login();
    throw e;
  }
}

export function onRequestFailed(error: AxiosError) {
  return Promise.reject(error);
}
